import { render, staticRenderFns } from "./knowledgeOverview.vue?vue&type=template&id=72745e54&scoped=true"
import script from "./knowledgeOverview.vue?vue&type=script&lang=js"
export * from "./knowledgeOverview.vue?vue&type=script&lang=js"
import style0 from "./knowledgeOverview.vue?vue&type=style&index=0&id=72745e54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72745e54",
  null
  
)

export default component.exports